<template>
	<a :href="`https://youtube.com/watch?v=${videoid}`" target="_blank" id="v-shelf">
		<div class="v-shelf-wrapper">

			<div class="v-shelf-video-container">

				<img width="140px" :src="`https://i.ytimg.com/vi_webp/${videoid}/mqdefault.webp`">

			</div>

			<div class="v-shelf-content">

				<span class="v-shelf-content-heading">Watch Dale Investigate:</span>
				<span class="v-shelf-content-text">{{ title }}</span>

			</div>

			<div class="v-shelf-actions relative">

				<button type="button" class="btn btn-trans" @click.stop.prevent="close()">
					<i class="fa fa-times fa-lg"></i>
				</button>

			</div>

		</div>

	</a>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'VideoShelf',
	props: {
		title: String,
		videoid: {
			type: String,
			required: true
		}
	},
	methods: {
		close(): void {
			this.$cookies.set('hidevshelf', true);
			this.$el.classList.remove('stuck');
			document.body.classList.remove('shelf-showing');
			this.$el.remove();
		},
	},
	mounted() {
		if (!this.$cookies.get('hidevshelf')) {
			this.$el.classList.add('stuck');
			document.body.classList.add('shelf-showing');
		} else {
			this.$el.remove();
		}
	}
})
</script>

<style lang="scss" scoped>

#v-shelf {
	position: fixed;
	left: 50%;
	bottom: 0;
	z-index: 10;
	width: 90%;
	max-width: 900px;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	transform: translateX(-50%);
	background: gold;
	box-shadow: 0 1px 2px 3px rgb(0 0 0 / 30%);
	overflow: hidden;
	height: 90px;
	padding: 8px 20px;
	cursor: pointer;

	&.stuck {
		animation: slide;
		animation-delay: 1000ms;
	}

	@media (min-width: 596px) and (max-width: 767px) {
		min-height: 90px;
	}

	@media screen and (min-width: 992px) {
		height: 100px;
	}

	.v-shelf-wrapper {
		position: relative;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		max-width: 1200px;
		overflow: hidden;
		height: 100%;
		margin: 0 auto;
		margin-bottom: 20px;
	}

	.v-shelf-video-container {
		flex: 0 1 auto;
	}

	.v-shelf-content {
		flex: 1 1 auto;
		padding: 0 10px;
		color: #000;
		overflow: hidden;

		.v-shelf-content-heading {
			font-size: 14px;
			line-height: 15px;

			@media (min-width: 596px) {
				font-size: 15px;
				line-height: 20px;
			}
		}

		.v-shelf-content-text {
			font-size: 16px;
			font-weight: 600;
			white-space: nowrap;
			text-overflow: ellipsis;
			display: block;
			overflow: hidden;

			@media (min-width: 596px) {
				font-size: 18px;
				line-height: 24px;
			}
		}

	}

	.v-shelf-actions {
		display: flex;
		flex-flow: row nowrap;
		flex: 0 1 auto;
	}

}

</style>
